import { triggerLogout } from '@/auth/sessionManager'

export const handleApiError = (error: any): void => {
  const status = error?.response?.status

  switch (status) {
    case 401:
      console.warn('Unauthorized. Logging out...')
      // Optionally clear tokens and redirect to login
      triggerLogout()
      break

    case 403:
      console.warn('Forbidden. You do not have access to this resource.')
      // Optionally show a toast or redirect
      break

    case 404:
      console.warn('Resource not found.')
      break

    case 500:
      console.error('Server error. Please try again later.')
      break

    default:
      console.error('Unhandled API error:', error.message || error)
  }
}
